import useLayoutVisibility from './useLayoutVisibility'

export const GLOBAL_HEADER_HEIGHT_CSS = 'var(--header-height, 61px)'
export const FULL_VIEWPORT_HEIGHT_CSS = '100vh'

// Canonical formula for "vertical space taken by chrome above the content", so every
// experience subtracts the kiosk chrome the same way instead of each reinventing its
// own calc()/fallback. `hasStationMenu` opts into `--station-menu-height`: the legacy
// StationMenu bar publishes its measured height and the floating ExperienceNavControls
// publish 0px (they displace no layout); where it is unset the fallback is whatever
// chrome height applies (the global header, or none).
export const getAvailableViewportHeightCss = ({ hasGlobalHeader = false, hasStationMenu = false } = {}) => {
  const chromeHeightCss = hasGlobalHeader ? GLOBAL_HEADER_HEIGHT_CSS : '0px'
  const effectiveChromeHeightCss = hasStationMenu ? `var(--station-menu-height, ${chromeHeightCss})` : chromeHeightCss

  return effectiveChromeHeightCss === '0px'
    ? FULL_VIEWPORT_HEIGHT_CSS
    : `calc(${FULL_VIEWPORT_HEIGHT_CSS} - ${effectiveChromeHeightCss})`
}

export default function useAvailableViewportHeightCss({ hasStationMenu = false } = {}) {
  const { effectiveShowHeader } = useLayoutVisibility()

  return getAvailableViewportHeightCss({ hasGlobalHeader: effectiveShowHeader, hasStationMenu })
}
